export const themeVars = {
    workspaceThemeGroups: {
        workspaceFont: 'workspace-font',
        workspaceBackground: 'workspace-background',
        applyMode: 'apply-mode',
        unsavedContentPrompt: 'unsaved-content-prompt'
    },

    section_widget: 'widget',
    section_formats: 'formats',

    hideMenuButtonViewMode: 'widget-hide-menu-button-view-mode',

    group_clickToFilter: 'group-click-to-filter',

    enableClickToFilter: 'use-click-to-filter',
    clickToFilterMode: 'click-to-filter-mode',
    drillThroughWorkspaceID: 'drill-through-workspace-id',
    drillThroughMode: 'drill-through-mode',
    drillThroughTabTitleTemplate: 'drill-through-tab-title-template',

    nullHandling_behaviour: 'nullHandling-behaviour',
    nullHandling_replaceForString: 'nullHandling-replace-string',
    nullHandling_replaceForNumeric: 'nullHandling-replace-numeric',
    nullHandling_replaceForDate: 'nullHandling-replace-dates',
    nullHandling_replaceForBoolean: 'nullHandling-replace-boolean',

    utcOffsetSelector: 'utc-offset-selector',
    use24HoursFormat: 'widget-culture-24h',
    currencySelector: 'widget-currency-selector',
    fiscalFirstMonth: 'widget-fiscal-first-month',

    formats_boolean: 'formats-boolean',
    formats_date: 'formats-date',
    formats_datetime: 'formats-datetime',
    formats_time: 'formats-time',
    formats_fiscalYear: 'formats-fiscal-year',
    formats_integer: 'formats-integer',
    formats_real: 'formats-real',

    //color_scales_set: 'color-scales-set'  //LL: 08.04.19  old
    //color_scales_set: 'color-scales-set-try'  //LL: try
    color_scales_set: 'color-scales-set-new',

    discreteMapping_set: 'discreteMapping-set',

    //mapping_set: 'mapping-set',  //LL: 24.12.19
    mapping_set: 'mapping-set-LL', //LL: 24.12.19  TEMP

    entityAttributeMapping: 'entities-model-color-mapping', //LL: see in pdc-widget-entity-model-editor/ts/themes/main

    palette_set: 'palette-set',

    columnAutoWidth: 'column-auto-width',

    gridSearchPanelColor: 'grid-searchPanel-color',

    section_Buttons: 'workspace-toolbar-buttons',
    justifyButtons: 'workspace-toolbar-justify-toolbar-buttons',
    showResetButton: 'workspace-toolbar-show-reset-button',
    resetButtonShowMode: 'workspace-toolbar-reset-button-show-mode',
    showApplyButton: 'workspace-toolbar-show-apply-button',
    showRefreshButton: 'toolbar-show-refresh-button',
    refreshButtonShowMode: 'workspace-toolbar-refresh-button-show-mode',
    showBackButton: 'workspace-toolbar-show-back-button',
    backButtonShowMode: 'workspace-toolbar-back-button-show-mode',
    showFullScreenButton: 'workspace-toolbar-show-full-screen-button',
    fullScreenButtonShowMode: 'workspace-toolbar-full-screen-button-show-mode',

    unsavedContentPromptTitle: 'workspace-unsaved-content-prompt-title',
    unsavedContentPromptMessage: 'workspace-unsaved-content-prompt-message',

    widgetSQLTimeoutPeriod: 'widget-sql-timeout-period',
    widgetLayoutMakeFiltersLocal: 'widget-layout-make-filters-local',
    widgetWorkspaceMakeFiltersLocal: 'widget-workspace-container-make-filters-local',
    widget_AlwaysShowHeader: 'widget-always-show-header',
    widgetHeaderBackground: 'widget-header-bg',
    widgetHeaderForeColor: 'widget-header-fore-color',
    widgetMaxNumberOfRecords: 'widget-max-number-of-records',
    widgetShowExportToExcelButton: 'widget-show-export-to-excel-button',
    widgetShowPdfButton: 'widget-show-pdf-button',
    widgetShowPrintButton: 'widget-show-print-button',
    widgetLoadingPanelEnable: 'widget-loading-panel-enable',

    navigationBar_PinnedByDefault: 'navbar-pinned-by-default',

    backgroundImage: 'workspace-bg-image',
    tabIcon: 'workspace-tab-icon',
    workspaceAutoupdateInterval: 'workspace-autoupdate-interval',

    itemSelector_ItemListBackgroundColor: 'item-selector-item-list-background-color',
    itemSelector_SearchHighlightingColor: 'item-selector-search-highlighting-color',
    itemSelector_SelectedItemForegroundColor: 'item-selector-selected-item-foreground-color',
    itemSelector_SelectedItemBackgroundColor: 'item-selector-selected-item-background-color',
    itemSelector_SelectedHiddenItemBackgroundColor: 'item-selector-hidden-items-background-color',
    itemSelector_SearchFromStartOnly: 'item-selector-search-from-start-only',
    itemSelector_ValidItemBackgroundColor: 'item-selector-valid-item-background-color',
    itemSelector_InvalidItemBackgroundColor: 'item-selector-invalid-item-background-color'
};
